import { useCallback } from 'react';

import type { Id } from '@e-socna/data-layer';

import { printSettingsForm2ApiMapper } from '../../../components/DocumentEditor/mappers/print-settings.form2api.mapper';
import type { OnSavePrintSettingsHandler } from '../../../components/DocumentEditor/types/props.type';

import { useUpdateDocumentTemplatePrintSettingsMutation } from './useUpdatePrintSettingsMutation.hook';
import { useQueryInvalidation } from './useQueryInvalidation.hook';

interface Params {
  readonly documentTemplateId: Id;
}

export const useSavePrintSettingsHandler = ({
  documentTemplateId,
}: Readonly<Params>) => {
  const { invalidateQueries } = useQueryInvalidation(documentTemplateId);
  const { mutateAsync: updatePrintSettings } =
    useUpdateDocumentTemplatePrintSettingsMutation();

  const onSavePrintSettings = useCallback<OnSavePrintSettingsHandler>(
    async (printSettings) => {
      await updatePrintSettings({
        printableId: documentTemplateId,
        printSettings: printSettingsForm2ApiMapper(printSettings),
      });
      invalidateQueries();
    },
    [documentTemplateId, invalidateQueries, updatePrintSettings],
  );

  return { onSavePrintSettings };
};
